import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import usersApi from "../../api/userApi";
import Pagination from "../../components/Pagination";

const Customers = () => {
 const [customers, setCustomers] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    fetchCustomers();
  }, [page, pageSize, sortedColumn, sortOrder]);

  const fetchCustomers = async () => {
    try {
      const response = await usersApi.getUsersList(
        page,
        pageSize,
        sortedColumn,
        sortOrder,
      "CUSTOMER",
      );
      setCustomers(response.data.content || []);
      setTotalPages(response.data.totalPages || 0);
    } catch (error) {
      console.error("Error fetching customers   :", error);
      setCustomers([]);
      setTotalPages(0);
      console.error("Error fetching customers   :", error);
    }
  };

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));
    setPage(selectedPage);
    localStorage.setItem("userCreditListAdmin", selectedPage);
  };

  return (
    <div>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Country</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer, index) => (
            <tr key={customer.userId}>
              <td>{customer.userId}</td>
              <td>{customer.userName}</td>
              <td>{customer.userEmail}</td>
              <td>{customer.countryName}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div style={{ marginTop: "auto" }}>
        {customers.length > 0 && totalPages > 0 && (
          <Pagination
            page={page}
            pageSize={pageSize}
            totalPages={totalPages}
            handlePageSizeChange={handlePageSizeChange}
            handlePageClick={handlePageClick}
          />
        )}
      </div>
    </div>
  );
};
export default Customers
